import React, { useState, useEffect } from "react";
import formatDateAndTime from "../../common/formatDateAndTime";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import EditSquareIcon from "@mui/icons-material/EditSquare";
import Steppers from "./Stepper";
import { Modal, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Previewcomponent from "../../common/Previewcomponent";
import { BlinkBlur } from "react-loading-indicators";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Commonmodal from "../../common/Commonmodal";
import getactions from "../../common/getactions";
import { useSelector } from "react-redux";

const ReviewTextWithReadMore = ({ text = "", limit = 120 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return <span className="text-gray-400">N/A</span>;
  if (text.length <= limit) {
    return <p className="whitespace-pre-line text-sm text-[#34495e]">{text}</p>;
  }

  return (
    <div className="text-sm text-[#34495e]">
      <p className="whitespace-pre-line">
        {expanded ? text : `${text.slice(0, limit)}...`}
      </p>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="text-xs font-semibold text-[#2376FF] hover:underline mt-1 focus:outline-none"
      >
        {expanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
};

const MultiImageCarousel = ({ attachments = [], onImageClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!attachments || attachments.length === 0) {
    return <span className="text-gray-400">N/A</span>;
  }

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? attachments.length - 1 : prev - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === attachments.length - 1 ? 0 : prev + 1));
  };

  const currentItem = attachments[currentIndex];

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-20 h-20 rounded-lg overflow-hidden border border-gray-200 bg-gray-50 flex items-center justify-center group">
        <img
          src={currentItem?.url}
          alt={currentItem?.fileName || "attachment"}
          onClick={() => onImageClick(currentItem?.url)}
          className="w-full h-full object-cover cursor-pointer hover:opacity-90 transition-opacity"
        />

        {attachments.length > 1 && (
          <>
            <button
              type="button"
              onClick={handlePrev}
              className="absolute left-0.5 top-1/2 -translate-y-1/2 bg-black/60 text-white rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <ArrowBackIosNewIcon sx={{ fontSize: 10 }} />
            </button>
            <button
              type="button"
              onClick={handleNext}
              className="absolute right-0.5 top-1/2 -translate-y-1/2 bg-black/60 text-white rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <ArrowForwardIosIcon sx={{ fontSize: 10 }} />
            </button>
          </>
        )}
      </div>

      {attachments.length > 1 && (
        <span className="text-[10px] text-gray-500 font-medium mt-1">
          {currentIndex + 1} / {attachments.length}
        </span>
      )}
    </div>
  );
};

const Tripstartenddetails = ({
  tripEndDetails,
  tripStartDetails,
  summaryDetails,
  vehicleDetails,
  fleetDeliveryAgentList,
  setLoading,
  loading,
}) => {
  const tripStartHubInputs = [
    {
      label: "Delivery Agent",
      type: "text",
      isEnable: true,
      placeholder: "Data will auto display",
      value: "delvieryagent",
      paraValue: null,
    },
    {
      label: "Current Odometer Reading",
      type: "text",
      isEnable: false,
      placeholder: "Enter Odometer Reading",
      value: "currentodometerreading",
      paraValue: vehicleDetails?.currentOdometer,
    },
    {
      label: "Current Fuel Reading",
      type: "text",
      isEnable: false,
      placeholder: "Enter Fuel Reading",
      value: "currentfuelreading",
      paraValue: vehicleDetails?.currentFuelVolumne,
    },
    {
      label: "Fuel Volume Comment (Reason why is low or high)",
      type: "text",
      isEnable: false,
      placeholder: "Enter Description",
      value: "enterdescription",
      paraValue: null,
    },
    {
      label: "Upload Image",
      type: "file",
      isEnable: false,
      placeholder: "",
      value: "uploadimage",
      paraValue: null,
    },
  ];

  const tripEndInputs = [
    {
      label: "Delivery Agent",
      type: "text",
      isEnable: false,
      placeholder: "Enter text",
      value: "delvieryagent",
    },
    {
      label: "Current Odometer Reading",
      type: "text",
      isEnable: false,
      placeholder: "Enter Odometer Reading",
      value: "currentodometerreading",
    },
    {
      label: "Current Fuel Reading",
      type: "text",
      isEnable: false,
      placeholder: "Enter Fuel Reading",
      value: "currentfuelreading",
    },
    {
      label: "End Date",
      type: "date",
      isEnable: false,
      placeholder: "",
      value: "enddate",
    },
    {
      label: "End Time",
      type: "time",
      isEnable: false,
      placeholder: "",
      value: "endtime",
    },
    {
      label: "Extra Hrs",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "extrshrs",
    },
    {
      label: "Extra Hrs Charges",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "extrshrscharges",
    },
    {
      label: "Extra Km",
      type: "text",
      isEnable: false,
      placeholder: "Enter Description",
      value: "extrakms",
    },
    {
      label: "Extra Km Charge",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "extrakmcharge",
    },
    {
      label: "Comment",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "comment",
    },
    {
      label: "Uplaod Image",
      type: "file",
      isEnable: false,
      placeholder: "",
      value: "uploadimage",
    },
  ];

  const tripEndHubInputs = [
    {
      label: "Current Odometer Reading",
      type: "text",
      isEnable: false,
      placeholder: "Enter Odometer Reading",
      value: "currentodometerreading",
    },
    {
      label: "Current Fuel Reading",
      type: "text",
      isEnable: false,
      placeholder: "Enter Fuel Reading",
      value: "currentfuelreading",
    },
    {
      label: "Delivery Charges",
      type: "text",
      isEnable: false,
      placeholder: "Enter Delivery Charges",
      value: "deliverycharge",
    },
    {
      label: "Upload Image",
      type: "file",
      isEnable: false,
      placeholder: "",
      value: "uploadimage",
    },
  ];

  const tripStartInputs = [
    {
      label: "Start Date",
      type: "date",
      isEnable: false,
      placeholder: "Enter Start Date",
      value: "startdate",
    },
    {
      label: "Start Time",
      type: "time",
      isEnable: false,
      placeholder: "Enter Start Time",
      value: "starttime",
    },
    {
      label: "Delivery Agent",
      type: "text",
      isEnable: true,
      placeholder: "",
      value: "deliveryagent",
    },
    {
      label: "Current Odometer Reading",
      type: "text",
      isEnable: false,
      placeholder: "Enter Odometer Reading",
      value: "currentodometerreading",
    },
    {
      label: "Current Fuel Reading",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "currentfuelreading",
    },
    {
      label: "Delivery Charges",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "deliverycharges",
    },
    {
      label: "Comment",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "comment",
    },
    {
      label: "Upload Image",
      type: "file",
      isEnable: false,
      placeholder: "",
      value: "uplaodimage",
    },
  ];

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const isSystemUserDataList = useSelector(
    (state) => state?.isSystemUser?.isSysTemUserData?.entities?.rows,
  );
  const token = localStorage.getItem("token");
  const [overtimeDetails, setOvertimeDetails] = useState([]);
  const [customerReviews, setCustomerReviews] = useState([]);

  const fetchOvertimeDetails = async () => {
    if (!summaryDetails?.id) return;
    try {
      const response = await fetch(
        `${apiUrl}/api/overtimedetails?bookingId=${summaryDetails.id}`,
        {
          method: "GET",
          headers: { Authorization: `${token}` },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const matchedRows = data.entities.rows.filter(
          (row) => row.bookingId === summaryDetails.id,
        );
        setOvertimeDetails(matchedRows);
      }
    } catch (error) {
      console.error("Error fetching overtime details:", error);
    }
  };

  const fetchCustomerReviews = async () => {
    if (!summaryDetails?.id) return;
    try {
      const response = await fetch(
        `${apiUrl}/api/customerreviews?bookingId=${summaryDetails.id}`,
        {
          method: "GET",
          headers: { Authorization: `${token}` },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const matchedRows = (data?.entities?.rows || []).filter(
          (row) => row.bookingId === summaryDetails.id,
        );
        setCustomerReviews(matchedRows);
      }
    } catch (error) {
      console.error("Error fetching customer reviews:", error);
    }
  };

  useEffect(() => {
    fetchOvertimeDetails();
    fetchCustomerReviews();
  }, [summaryDetails?.id, apiUrl, token]);

  const profile = JSON.parse(localStorage.getItem("profile"));
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const [activeStep, setActiveStep] = useState(0);
  const [editTripStartDetails, setEditTripStartDetails] = useState(false);
  const [editTripEndDetails, setEditTripEndDetails] = useState(false);
  const [tripstartHubDetails, setTripStartHubDetails] = useState({
    deliveryagent: "",
    currentodometerreading: "",
    currentfuelreading: "",
    enterdescription: "",
  });
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const [rejectionComment, setRejectionComment] = useState("");

  const [tripstartTripDetails, setTripStartTripDetails] = useState({
    startDate: "",
    startTime: "",
    deliveryAgent: "",
    currentFuelReading: "",
    currentOdometerReading: "",
    deliveryCharges: "",
    comment: "",
  });
  const [openImage, setOpenImage] = useState(false);
  const [imageSelection, setImageSelection] = useState(null);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [selectedVerifyItem, setSelectedVerifyItem] = useState(null);
  const [verifying, setVerifying] = useState(false);

  // Customer Review Verify Modal State
  const [openReviewVerifyModal, setOpenReviewVerifyModal] = useState(false);
  const [selectedReviewItem, setSelectedReviewItem] = useState(null);
  const [verifyingReview, setVerifyingReview] = useState(false);

  const handleOpenVerifyModal = (item) => {
    setSelectedVerifyItem(item);
    setOpenVerifyModal(true);
  };

  const handleCloseVerifyModal = () => {
    setSelectedVerifyItem(null);
    setOpenVerifyModal(false);
  };

  const handleOpenReviewVerifyModal = (item) => {
    setSelectedReviewItem(item);
    setOpenReviewVerifyModal(true);
  };

  const handleCloseReviewVerifyModal = () => {
    setSelectedReviewItem(null);
    setOpenReviewVerifyModal(false);
  };

  const handleConfirmVerify = async (type) => {
    if (!selectedVerifyItem) return;
    let payload;
    if (type === "verify") {
      payload = {
        id: selectedVerifyItem.id,
        isVerified: true,
        bookingId: selectedVerifyItem.bookingId,
      };
    } else {
      payload = {
        id: selectedVerifyItem.id,
        isRejected: true,
        bookingId: selectedVerifyItem.bookingId,
        rejectionComment: rejectionComment,
      };
    }
    setVerifying(true);
    try {
      const response = await fetch(`${apiUrl}/api/overtimedetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data?.statusCode === "0100" || response.ok) {
        const currentTime = new Date().toISOString();
        setOvertimeDetails((prev) =>
          prev.map((row) =>
            row.id === selectedVerifyItem.id
              ? {
                  ...row,
                  isVerified: true,
                  updatedAt: data?.dataValues?.updatedAt || currentTime,
                }
              : row,
          ),
        );
        handleCloseVerifyModal();
        await fetchOvertimeDetails();
      } else {
        console.error("Failed to verify overtime record:", data);
      }
    } catch (error) {
      console.error("Error during overtime verification API call:", error);
    } finally {
      setVerifying(false);
    }
  };

  const handleConfirmReviewVerify = async () => {
    if (!selectedReviewItem) return;
    setVerifyingReview(true);
    try {
      const payload = {
        id: selectedReviewItem.id,
        isVerified: true,
        bookingId: selectedReviewItem.bookingId,
      };

      const response = await fetch(`${apiUrl}/api/customerreviews`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data?.statusCode === "0100" || response.ok) {
        setCustomerReviews((prev) =>
          prev.map((row) =>
            row.id === selectedReviewItem.id
              ? { ...row, isVerified: true, verifiedBy: profile?.id }
              : row,
          ),
        );
        handleCloseReviewVerifyModal();
        await fetchCustomerReviews();
      } else {
        console.error("Failed to verify review:", data);
      }
    } catch (error) {
      console.error("Error during review verification:", error);
    } finally {
      setVerifyingReview(false);
    }
  };

  const handleImageClose = () => {
    setImageSelection(null);
    setOpenImage(false);
  };

  const handleImageOpen = (url) => {
    setImageSelection(url);
    setOpenImage(true);
  };

  const normalizeReviewAttachment = (attachment) => {
    if (!attachment) return [];
    if (Array.isArray(attachment)) return attachment;
    return [attachment];
  };

  const steps = [
    {
      label: "Hub Start Details",
      description: (
        <div>
          {tripStartHubInputs.map((item, index) => {
            return (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-4 gap-2 my-8 mx-auto w-full max-w-4xl"
              >
                <label
                  htmlFor={item?.value}
                  className="text-gray-700 font-medium md:col-span-2 self-center"
                >
                  {item?.label}
                </label>

                <div className="md:col-span-2 flex flex-col">
                  <input
                    id={item?.value}
                    name={item?.value}
                    placeholder={item?.placeholder || "Enter value"}
                    onChange={(e) => {
                      setTripStartHubDetails((prev) => ({
                        ...prev,
                        [item.value]: e.target.value,
                      }));
                    }}
                    disabled={item?.isEnable}
                    type={item?.type || "text"}
                    className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                  />
                  <p className="text-xs text-end font-medium text-gray-600 mt-2">
                    {item?.paraValue && "* Current Reading -"} {item?.paraValue}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      ),
    },
    {
      label: "Trip Start Details",
      description: (
        <div>
          {tripStartInputs.map((item, index) => {
            return (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-4 gap-2 my-8 mx-auto w-full max-w-4xl"
              >
                <label
                  htmlFor={item?.value}
                  className="text-gray-700 font-medium md:col-span-2 self-center"
                >
                  {item?.label}
                </label>

                <div className="md:col-span-2 flex flex-col">
                  <input
                    id={item?.value}
                    name={item?.value}
                    placeholder={item?.placeholder || "Enter value"}
                    onChange={(e) => {
                      setTripStartHubDetails((prev) => ({
                        ...prev,
                        [item.value]: e.target.value,
                      }));
                    }}
                    disabled={item?.isEnable}
                    type={item?.type || "text"}
                    className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                  />
                  <p className="text-xs text-end font-medium text-gray-600 mt-2">
                    {item?.paraValue && "* Current Reading -"} {item?.paraValue}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      ),
    },
  ];

  const tripEndSteps = [
    {
      label: "Trip End Details",
      description: (
        <div>
          {tripEndInputs.map((item, index) => {
            return (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-3 gap-2 my-4 mx-auto w-full max-w-4xl"
              >
                <label
                  htmlFor={item?.value}
                  className="text-gray-700 font-medium self-center"
                >
                  {item?.label}
                </label>

                <input
                  id={item?.value}
                  name={item?.value}
                  placeholder={item?.placeholder || "Enter value"}
                  onChange={(e) => {
                    setTripStartHubDetails((prev) => ({
                      ...prev,
                      [item.value]: e.target.value,
                    }));
                  }}
                  type={item?.type || "text"}
                  className="md:col-span-2 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                />
              </div>
            );
          })}
        </div>
      ),
    },
    {
      label: "Hub End Details",
      description: (
        <div>
          {tripEndHubInputs.map((item, index) => {
            return (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-3 gap-2 my-4 mx-auto w-full max-w-4xl"
              >
                <label
                  htmlFor={item?.value}
                  className="text-gray-700 font-medium self-center"
                >
                  {item?.label}
                </label>

                <input
                  id={item?.value}
                  name={item?.value}
                  onChange={(e) => {
                    setTripStartTripDetails((prev) => ({
                      ...prev,
                      [item.value]: e.target.value,
                    }));
                  }}
                  placeholder={item?.placeholder || "Enter value"}
                  type={item?.type || "text"}
                  className="md:col-span-2 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                />
              </div>
            );
          })}
        </div>
      ),
    },
  ];

  const handleNext = async (type) => {
    if (type === "Save Data") {
      try {
        const response = await fetch(`${apiUrl}/api/deliverynrks`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            bookingId: summaryDetails?.id,
            bookingCode: summaryDetails?.bookingCode,
            vehicleId: vehicleDetails?.licensePlate,
            startingOdometer: vehicleDetails?.onBoardingOdometer,
            startingFuelVolume: vehicleDetails?.currentFuelVolumne,
            fleetExecutiveName: "Sharaths S",
            fleetExecutiveId: 3063,
            image:
              "https://wowcarz-file-upload.s3.amazonaws.com/vehicles/images-1754641664793-user.jpg",
            fuelComment: "322test",
            nkrObject: {
              bookingId: summaryDetails?.id,
              vehicleName: vehicleDetails?.name,
              tripStart: "2025-08-08 13:57:48",
              tripReason: "Booking Delivery",
              driverId: 3063,
              driverName: "Sharaths S",
              startOdometer: 122,
              startOdometerImage:
                "https://wowcarz-file-upload.s3.amazonaws.com/vehicles/images-1754641664793-user.jpg",
              startFuelLevel: 14,
              vehicleRegistrationNo: "KA09MJ2746",
              driverEmail: "sharath_mysfranchise@wowcarz.in",
              cityId: 2,
              hubId: 3,
              hubName: "MYSORE",
              bookingCode: summaryDetails?.bookingCode,
              comment: "",
              vehicleId: vehicleDetails?.id,
            },
            fuelHistoryObject: {
              vehicleId: 97,
              registrationNo: "KA09MJ2746",
              lastVolume: 10,
              currentVolume: 14,
              bookingId: 3003,
              newUpdatedOn: "2025-08-08",
            },
          }),
        });
        const data = await response.json();
        if (!data) {
          console.error("Unexpected API response:", data);
        }
      } catch (error) {
        console.error("Error fetching post hub details:", error);
      }
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <>
      {openImage && (
        <Commonmodal
          open={openImage}
          onClose={handleImageClose}
          url={imageSelection}
        />
      )}

      {/* Overtime Verification Modal */}
      {openVerifyModal && (
        <Modal open={openVerifyModal} onClose={handleCloseVerifyModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50vh)",
              width: 400,
              bgcolor: "background.paper",
              borderRadius: "8px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography
              variant="h6"
              component="h2"
              sx={{ fontWeight: 600, color: "#2c3e50", mb: 2 }}
            >
              Confirm Verification for {selectedVerifyItem?.empName}
            </Typography>
            <div className="w-full">
              <label
                htmlFor="rejectionComment"
                className="block mb-2 text-sm font-medium text-gray-700"
              >
                Rejection Comment
              </label>

              <textarea
                id="rejectionComment"
                value={rejectionComment}
                onChange={(e) => setRejectionComment(e.target.value)}
                placeholder="Enter rejection comment"
                rows={4}
                className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm
                   outline-none transition
                   focus:border-red-500 focus:ring-2 focus:ring-red-100
                   resize-none"
              />
            </div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 4,
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCloseVerifyModal}
                disabled={verifying}
                sx={{ borderColor: "#D1D5DB", color: "#374151" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  handleConfirmVerify("reject");
                }}
                disabled={verifying}
                sx={{ bgcolor: "#db5126", "&:hover": { bgcolor: "#da3605" } }}
              >
                {verifying ? "Rejecting..." : "Reject"}
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  handleConfirmVerify("verify");
                }}
                disabled={verifying}
                sx={{ bgcolor: "#34495e", "&:hover": { bgcolor: "#2c3e50" } }}
              >
                {verifying ? "Verifying..." : "Verify"}
              </Button>
            </Box>
          </Box>
        </Modal>
      )}

      {/* Customer Review Verification Modal */}
      {openReviewVerifyModal && (
        <Modal
          open={openReviewVerifyModal}
          onClose={handleCloseReviewVerifyModal}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              borderRadius: "8px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography
              variant="h6"
              component="h2"
              sx={{ fontWeight: 600, color: "#2c3e50", mb: 2 }}
            >
              Confirm Review Verification
            </Typography>
            <Typography sx={{ color: "#4B5563", fontSize: 14, mb: 3 }}>
              Are you sure you want to verify the review added by{" "}
              <strong>{selectedReviewItem?.fleetExecutiveName}</strong>?
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 4,
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCloseReviewVerifyModal}
                disabled={verifyingReview}
                sx={{ borderColor: "#D1D5DB", color: "#374151" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleConfirmReviewVerify}
                disabled={verifyingReview}
                sx={{ bgcolor: "#34495e", "&:hover": { bgcolor: "#2c3e50" } }}
              >
                {verifyingReview ? "Verifying..." : "Verify"}
              </Button>
            </Box>
          </Box>
        </Modal>
      )}

      <div className="md:p-6">
        <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
          Trip Start & End Details
        </h2>

        {!loading ? (
          <div className="overflow-hidden rounded-lg shadow mb-8">
            <table className="w-full text-left bg-white">
              <thead className="bg-[#34495e] text-white">
                <tr>
                  <th className="px-6 py-4 text-left" colSpan={2}>
                    Trip Start Details
                  </th>
                </tr>
              </thead>
              {tripStartDetails.length > 0 || !editTripStartDetails ? (
                <tbody className="text-sm divide-y divide-gray-200">
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Actual Trip Start Date & Time
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {tripStartDetails[0]
                        ? formatDateAndTime(
                            tripStartDetails[0]?.tripStartDateAndTime,
                          )
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Pickup Location
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {summaryDetails?.deliveryAddress || "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Odometer Reading
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {(tripStartDetails[0]?.startingOdometer &&
                        tripStartDetails[0]?.startingOdometer + " / KMs") ||
                        "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Fuel Level
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {(tripStartDetails[0]?.startingFuelVolume &&
                        tripStartDetails[0]?.startingFuelVolume + " % ") ||
                        "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Handover Staff
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {tripStartDetails[0]?.fleetExecutiveName
                        ? tripStartDetails[0]?.fleetExecutiveName
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Comment
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {tripStartDetails ? tripStartDetails[0]?.comment : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Odometer Image
                    </td>
                    {tripStartDetails[0]?.odometerImage ? (
                      <img
                        src={
                          tripStartDetails &&
                          tripStartDetails[0]?.odometerImage
                        }
                        onClick={() => {
                          handleImageOpen(
                            tripStartDetails &&
                              tripStartDetails[0]?.odometerImage,
                          );
                        }}
                        alt="trip start odometer image"
                        className="px-2 py-3 text-[#34495e] h-24 w-24 rounded-lg cursor-pointer"
                      />
                    ) : (
                      <>
                        <h1 className="px-6 py-3 text-[#34495e]">N/A</h1>
                      </>
                    )}
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Extra Attachments
                    </td>
                    {tripStartDetails[0]?.attachments ? (
                      <div className="grid grid-cols-8">
                        {JSON.parse(tripStartDetails[0]?.attachments)?.map(
                          (item, index) => (
                            <img
                              key={index}
                              src={item?.url}
                              onClick={() => handleImageOpen(item?.url)}
                              alt="trip start odometer image"
                              className="px-2 py-3 text-[#34495e] h-24 w-24 rounded-lg cursor-pointer"
                            />
                          ),
                        )}
                      </div>
                    ) : (
                      <h1 className="px-6 py-3 text-[#34495e]">N/A</h1>
                    )}
                  </tr>
                </tbody>
              ) : (
                <Box
                  sx={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <Stepper activeStep={activeStep} orientation="vertical">
                    {steps.map((step, index) => (
                      <Step key={step.label}>
                        <StepLabel
                          optional={
                            index === steps.length - 1 ? (
                              <Typography variant="caption">
                                Last step
                              </Typography>
                            ) : null
                          }
                        >
                          {step.label}
                        </StepLabel>
                        <StepContent>
                          {step.description}
                          <Box sx={{ mb: 2 }}>
                            <Button
                              variant="contained"
                              onClick={(e) => {
                                handleNext(
                                  index === steps.length - 1
                                    ? "Start the trip"
                                    : "Save Data",
                                );
                              }}
                              sx={{ mt: 1, mr: 1 }}
                            >
                              {index === steps.length - 1
                                ? "Start the trip"
                                : "Save Data"}
                            </Button>
                            <Button
                              disabled={index === 0}
                              onClick={handleBack}
                              sx={{ mt: 1, mr: 1 }}
                            >
                              Back
                            </Button>
                          </Box>
                        </StepContent>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              )}
            </table>
          </div>
        ) : (
          <BlinkBlur color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]} />
        )}

        {String(summaryDetails?.bookingStatus) !==
        fleetBookingStatus?.inverted?.bookingConfirmed ? (
          <div className="overflow-hidden rounded-lg shadow mb-8">
            <table className="w-full text-left bg-white">
              <thead className="bg-[#34495e] text-white">
                <tr>
                  <th className="px-6 py-4 text-left" colSpan={2}>
                    Trip End Details
                  </th>
                </tr>
              </thead>

              {tripStartDetails.length > 0 || !editTripEndDetails ? (
                <tbody className="text-sm divide-y divide-gray-200">
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Actual Trip End Date & Time
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {tripEndDetails[0]
                        ? formatDateAndTime(
                            tripEndDetails[0]?.tripEndDateAndTime,
                          )
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Return Location
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {summaryDetails?.pickupAddress || "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      End Odometer
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {tripEndDetails[0]?.endingOdometer
                        ? tripEndDetails[0]?.endingOdometer + " / KMs"
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Fuel Level
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {tripEndDetails[0]?.endingFuelVolume
                        ? tripEndDetails[0]?.endingFuelVolume + " %"
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Handover Staff
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {tripEndDetails
                        ? tripEndDetails[0]?.fleetExecutiveName
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Comment
                    </td>
                    <td className="px-6 py-3 text-[#34495e]">
                      {tripEndDetails ? tripEndDetails[0]?.comment : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Odometer Image
                    </td>
                    {tripEndDetails[0]?.odometerImage ? (
                      <img
                        onClick={() => {
                          handleImageOpen(
                            tripEndDetails &&
                              tripEndDetails[0]?.odometerImage,
                          );
                        }}
                        src={
                          tripEndDetails && tripEndDetails[0]?.odometerImage
                        }
                        alt="endodometerimage"
                        className="px-2 py-3 text-[#34495e] h-24 w-24 rounded-lg cursor-pointer"
                      />
                    ) : (
                      <>
                        <h1 className="px-6 py-3 text-[#34495e]">N/A</h1>
                      </>
                    )}
                  </tr>
                  <tr>
                    <td className="font-semibold px-6 py-3 text-[#2c3e50]">
                      Extra Attachments
                    </td>
                    {tripEndDetails[0]?.attachments ? (
                      <div className="grid grid-cols-8">
                        {JSON.parse(tripEndDetails[0]?.attachments)?.map(
                          (item, index) => (
                            <img
                              key={index}
                              src={item?.url}
                              onClick={() => handleImageOpen(item?.url)}
                              alt="trip start odometer image"
                              className="px-2 py-3 text-[#34495e] h-24 w-24 rounded-lg cursor-pointer"
                            />
                          ),
                        )}
                      </div>
                    ) : (
                      <h1 className="px-6 py-3 text-[#34495e]">N/A</h1>
                    )}
                  </tr>
                </tbody>
              ) : (
                <Box
                  sx={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <Stepper activeStep={activeStep} orientation="vertical">
                    {tripEndSteps.map((step, index) => (
                      <Step key={step.label}>
                        <StepLabel
                          optional={
                            index === tripEndSteps.length - 1 ? (
                              <Typography variant="caption">
                                Last step
                              </Typography>
                            ) : null
                          }
                        >
                          {step.label}
                        </StepLabel>
                        <StepContent>
                          {step.description}
                          <Box sx={{ mb: 2 }}>
                            <Button
                              variant="contained"
                              onClick={handleNext}
                              sx={{ mt: 1, mr: 1 }}
                            >
                              {index === tripEndSteps.length - 1
                                ? "Finish"
                                : "Continue"}
                            </Button>
                            <Button
                              disabled={index === 0}
                              onClick={handleBack}
                              sx={{ mt: 1, mr: 1 }}
                            >
                              Back
                            </Button>
                          </Box>
                        </StepContent>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              )}
            </table>
          </div>
        ) : (
          <></>
        )}

        {/* Overtime Details Section */}
        {overtimeDetails.length > 0 && (
          <div className="overflow-hidden rounded-lg shadow mb-8">
            <table className="w-full text-left bg-white">
              <thead className="bg-[#34495e] text-white">
                <tr>
                  <th className="px-6 py-4">Record</th>
                  <th className="px-6 py-4">Agent Name</th>
                  <th className="px-6 py-4">Shift Start Time</th>
                  <th className="px-6 py-4">Shift End Time</th>
                  <th className="px-6 py-4">Total Shift Hrs</th>
                  <th className="px-6 py-4">Category</th>
                  <th className="px-6 py-4">Overtime Hrs</th>
                  <th className="px-6 py-4">OT Start Date & Time</th>
                  <th className="px-6 py-4">OT End Date & Time</th>
                  <th className="px-6 py-4">Created At</th>
                  <th className="px-6 py-4">Status</th>
                  {actionsToAccess?.includes("Approve Reject Overtime") && (
                    <th className="px-6 py-4">Verify</th>
                  )}
                </tr>
              </thead>
              <tbody className="text-sm divide-y divide-gray-200">
                {overtimeDetails.map((item, index) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="font-extrabold text-base text-[#2c3e50] px-6 py-4">
                      {index + 1}
                    </td>
                    <td className="px-6 py-4 text-[#34495e]">
                      {item.empName} ({item.empEmail})
                    </td>
                    <td className="px-6 py-4 text-[#34495e]">
                      {item.shiftStartTime
                        ? formatDateAndTime(item.shiftStartTime)
                        : "N/A"}
                    </td>
                    <td className="px-6 py-4 text-[#34495e]">
                      {item.shiftEndTime
                        ? formatDateAndTime(item.shiftEndTime)
                        : "N/A"}
                    </td>
                    <td className="px-6 py-4 text-[#34495e]">
                      {Number(item.totalShiftHrs || 0).toFixed(2)} Hrs
                    </td>
                    <td className="px-6 py-4 text-[#34495e] font-medium capitalize">
                      {item.overtimeEntity === "tripStart"
                        ? "Trip Start"
                        : item.overtimeEntity === "tripEnd"
                          ? "Trip End"
                          : item.overtimeEntity}
                    </td>
                    <td
                      className={`px-6 py-4 font-semibold ${item.overtimeHrs < 0 ? "text-red-600" : "text-green-600"}`}
                    >
                      {Number(item.overtimeHrs || 0).toFixed(2)} Hrs
                    </td>
                    <td className="px-6 py-4 text-[#34495e]">
                      {item.otStartDateTime
                        ? formatDateAndTime(item.otStartDateTime)
                        : "N/A"}
                    </td> 
                    <td className="px-6 py-4 text-[#34495e]">
                      {item.otEndDateTime
                        ? formatDateAndTime(item.otEndDateTime)
                        : "N/A"}
                    </td>
                    <td className="px-6 py-4 text-[#34495e]">
                      {item.createdAt
                        ? formatDateAndTime(item.createdAt)
                        : "N/A"}
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`px-2.5 py-1 rounded-full text-xs font-semibold ${item.isVerified ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"}`}
                      >
                        {item.isVerified
                          ? "Verified"
                          : item?.isRejected
                            ? "Rejected"
                            : "Not Verified"}
                      </span>
                    </td>
                    {actionsToAccess?.includes("Approve Reject Overtime") && (
                      <td className="px-6 py-4">
                        {item.isVerified ? (
                          <div>
                            <span className="text-xs font-medium text-gray-500">
                              Verified at{" "}
                              {item.verifiedAt
                                ? formatDateAndTime(item.verifiedAt)
                                : "N/A"}
                            </span>
                            <br />
                            <span>
                              {isSystemUserDataList?.find(
                                (usr) => usr?.id === item?.verifiedBy,
                              )?.name || "-"}
                            </span>
                          </div>
                        ) : item.isRejected ? (
                          <div>
                            <span className="text-xs font-medium text-gray-500">
                              Rejection Comment {item?.rejectionComment}
                            </span>
                            <br />
                            <span className="text-xs font-medium text-gray-500">
                              Rejected at{" "}
                              {item.rejectedAt
                                ? formatDateAndTime(item.rejectedAt)
                                : "N/A"}
                            </span>
                            <br />
                            <span>
                              {isSystemUserDataList?.find(
                                (usr) => usr?.id === item?.rejectedBy,
                              )?.name || "-"}
                            </span>
                          </div>
                        ) : (
                          <button
                            type="button"
                            onClick={() => handleOpenVerifyModal(item)}
                            className="px-3 py-1.5 bg-[#34495e] text-white text-xs font-semibold rounded hover:bg-[#2c3e50] transition-colors"
                          >
                            Action
                          </button>
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-gray-50 font-semibold text-sm text-[#2c3e50] border-t border-gray-200">
                <tr>
                  <td colSpan={6} className="px-6 py-3 text-right">
                    Total Net Overtime Hours:
                  </td>
                  <td
                    colSpan={
                      actionsToAccess?.includes("Approve Reject Overtime")
                        ? 5
                        : 4
                    }
                    className="px-6 py-3 text-left"
                  >
                    {overtimeDetails
                      .reduce((acc, curr) => acc + (curr.overtimeHrs || 0), 0)
                      .toFixed(2)}{" "}
                    Hrs
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}

        {/* Customer Reviews Section */}
        {customerReviews.length > 0 && (
          <div className="overflow-hidden rounded-lg shadow mb-8">
            <table className="w-full text-left bg-white">
              <thead className="bg-[#34495e] text-white">
                <tr>
                  <th className="px-6 py-4">#</th>
                  <th className="px-6 py-4">Executive Name</th>
                  <th className="px-6 py-4">Review Text</th>
                  <th className="px-6 py-4">Attachment</th>
                  <th className="px-6 py-4">Created Date</th>
                  <th className="px-6 py-4">Status</th>
                  {actionsToAccess?.includes("Approve Reject Customer Reviews") && (
                    <th className="px-6 py-4">Verify</th>
                  )}
                </tr>
              </thead>
              <tbody className="text-sm divide-y divide-gray-200">
                {customerReviews.map((item, index) => {
                  const attachments = normalizeReviewAttachment(
                    item.reviewAttachment,
                  );
                  return (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="font-extrabold text-base text-[#2c3e50] px-6 py-4">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 text-[#34495e]">
                        <span className="font-semibold">
                          {item.fleetExecutiveName || "N/A"}
                        </span>
                        <br />
                        <span className="text-xs text-gray-500">
                          {item.fleetExecutiveEmail ||
                            `Cust ID: ${item.customerId}`}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-[#34495e] max-w-md">
                        <ReviewTextWithReadMore
                          text={item.textReview}
                          limit={140}
                        />
                      </td>
                      <td className="px-6 py-4">
                        <MultiImageCarousel
                          attachments={attachments}
                          onImageClick={handleImageOpen}
                        />
                      </td>
                      <td className="px-6 py-4 text-[#34495e]">
                        {item.createdAt
                          ? formatDateAndTime(item.createdAt)
                          : "N/A"}
                      </td>
                      <td className="px-6 py-4">
                        <span
                          className={`px-2.5 py-1 rounded-full text-xs font-semibold ${item.isVerified ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"}`}
                        >
                          {item.isVerified ? "Verified" : "Not Verified"}
                        </span>
                      </td>
                      {actionsToAccess?.includes("Approve Reject Customer Reviews") && (
                        <td className="px-6 py-4">
                          {item.isVerified ? (
                            <div>
                              <span className="text-xs font-medium text-gray-500">
                                Verified
                              </span>
                              <br />
                              <span className="text-xs text-gray-600">
                                {isSystemUserDataList?.find(
                                  (usr) => usr?.id === item?.verifiedBy,
                                )?.name ||
                                  (item?.verifiedBy
                                    ? `ID: ${item?.verifiedBy}`
                                    : "N/A")}
                              </span>
                            </div>
                          ) : (
                            <button
                              type="button"
                              onClick={() => handleOpenReviewVerifyModal(item)}
                              className="px-3 py-1.5 bg-[#34495e] text-white text-xs font-semibold rounded hover:bg-[#2c3e50] transition-colors"
                            >
                              Action
                            </button>
                          )}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default Tripstartenddetails;  